import { ReactNode } from "react";
import { Symbols } from "./type";
import BigNumber from "bignumber.js";

const CleopatrasTreasureUtils = {
  isBuyingFreeSpin(bombCount: number): boolean {
    return bombCount >= 4;
  },
  cleanSymbolId(symbol: number): { symbolId: number; featureId: number } {
    const mod = symbol % 100;
    if (mod > 90) {
      const realSymbolId = +Math.floor(symbol / 100).toFixed(0);
      // 9X suffix, it is no regular symbol, need special handle
      if (mod === 91) {
        return { symbolId: realSymbolId, featureId: 1 };
      } else {
        return { symbolId: realSymbolId, featureId: +(mod - 90).toFixed(0) };
      }
    }
    if (symbol > 10 && symbol < 100 && symbol != Symbols.Scatter) {
      return {
        symbolId: +Math.floor(symbol / 10).toFixed(0),
        featureId: +(symbol % 10).toFixed(0),
      };
    }
    return {
      symbolId: symbol,
      featureId: NaN,
    };
  },
  takeSymbol(reelMatrix: number[][], x: number, y: number): number {
    return reelMatrix[x][y];
  },
  convertSymbol(symbol: number, key?: string): ReactNode {
    if (Number.isNaN(symbol)) return "";
    switch (symbol) {
      case Symbols.Coin5:
        return <img key={key} alt="Coin5" src="/ct/201.png" />;
      case Symbols.Coin6:
        return <img key={key} alt="Coin6" src="/ct/202.png" />;
      case Symbols.Coin7:
        return <img key={key} alt="Coin7" src="/ct/203.png" />;
      case Symbols.Coin8:
        return <img key={key} alt="Coin8" src="/ct/204.png" />;
      case Symbols.Coin1:
        return <img key={key} alt="Coin1" src="/ct/101.png" />;
      case Symbols.Coin2:
        return <img key={key} alt="Coin2" src="/ct/102.png" />;
      case Symbols.Coin3:
        return <img key={key} alt="Coin3" src="/ct/103.png" />;
      case Symbols.Coin4:
        return <img key={key} alt="Coin4" src="/ct/104.png" />;

      case Symbols.Scatter:
        return <img key={key} alt="Scatter" src="/ct/25.png" />;

      case 0:
        return <></>;
      default:
        return symbol;
    }
  },
  maxBetFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount).multipliedBy(50); // buy free spin rate
  },
  maxPayoutFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount)
      .multipliedBy(0.05) // bet size
      .multipliedBy(20) // 4*5 symbol count
      .multipliedBy(200) // base spin level 8 multiplier
      .multipliedBy(15); //  symbol payout
  },
} as const;

export default CleopatrasTreasureUtils;
